(function () {
  'use strict';

  var BAG_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M2.04766 18.566C1.98267 18.8583 1.98417 19.1615 2.05203 19.4532C2.1199 19.7449 2.2524 20.0176 2.43976 20.2513C2.62713 20.4849 2.86456 20.6735 3.13455 20.8031C3.40454 20.9326 3.70018 20.9999 3.99966 21H19.9997C20.2991 20.9999 20.5948 20.9326 20.8648 20.8031C21.1347 20.6735 21.3722 20.4849 21.5595 20.2513C21.7469 20.0176 21.8794 19.7449 21.9473 19.4532C22.0151 19.1615 22.0166 18.8583 21.9517 18.566L19.9517 9.566C19.8529 9.12187 19.6057 8.72468 19.2508 8.43998C18.896 8.15528 18.4546 8.00008 17.9997 8H5.99966C5.54469 8.00008 5.10335 8.15528 4.74847 8.43998C4.39359 8.72468 4.14638 9.12187 4.04766 9.566L2.04766 18.566Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 11V6C8 4.93913 8.42143 3.92172 9.17157 3.17157C9.92172 2.42143 10.9391 2 12 2C13.0609 2 14.0783 2.42143 14.8284 3.17157C15.5786 3.92172 16 4.93913 16 6V11" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function formatMoney(cents) {
    var amount = Math.round(cents) / 100;
    return '₹' + (amount % 1 === 0
      ? amount.toLocaleString('en-IN')
      : amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }

  function truncate(str, n) {
    return str.length > n ? str.slice(0, n - 1) + '…' : str;
  }

  function getImageUrl(url, width) {
    if (!url) return '';
    // Normalize protocol-relative URLs ("//cdn...") to absolute.
    var full = url.indexOf('//') === 0 ? 'https:' + url : url;
    // Fallback data (from Liquid) already carries a size via ?width= — use as-is.
    if (/[?&](width|height)=/.test(full)) return full;
    // Recommendations API returns an unsized master URL — insert a size suffix.
    return full.replace(/(\.[^./?]+)(\?.*)?$/, '_' + width + 'x$1');
  }

  function renderCard(product) {
    var variant = product.variants[0];
    var price = formatMoney(variant.price);
    var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
    var comparePrice = hasCompare ? formatMoney(variant.compare_at_price) : null;
    var discount = hasCompare ? Math.round((1 - variant.price / variant.compare_at_price) * 100) : null;
    var imgSrc = getImageUrl(product.featured_image, 300);
    var title = truncate(product.title, 50);
    var isMultiVariant = product.variants.length > 1;
    var isAvailable = variant.available;

    var imageHtml = imgSrc
      ? '<img class="related-product-card__image" src="' + imgSrc + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">'
      : '';

    var pricingHtml = '<div class="related-product-card__pricing">'
      + '<span class="related-product-card__price">' + price + '</span>'
      + (comparePrice ? '<span class="related-product-card__compare">' + comparePrice + '</span>' : '')
      + (discount ? '<span class="related-product-card__badge">' + discount + '% off</span>' : '')
      + '</div>';

    var atcHtml;
    if (isMultiVariant) {
      atcHtml = '<a href="' + product.url + '" class="related-product-card__atc">'
        + '<span class="related-product-card__atc-icon">' + BAG_ICON + '</span>'
        + '<span>View Options</span>'
        + '</a>';
    } else if (!isAvailable) {
      atcHtml = '<button class="related-product-card__atc" disabled>'
        + '<span>Sold Out</span>'
        + '</button>';
    } else {
      atcHtml = '<button class="related-product-card__atc" data-variant-id="' + variant.id + '">'
        + '<span class="related-product-card__atc-icon">' + BAG_ICON + '</span>'
        + '<span>Add to Cart</span>'
        + '</button>';
    }

    return '<div class="cart-fbt__item">'
      + '<article class="related-product-card">'
      + '<div class="related-product-card__top">'
      + '<a class="related-product-card__media" href="' + product.url + '">' + imageHtml + '</a>'
      + '<div class="related-product-card__info">'
      + '<a class="related-product-card__title" href="' + product.url + '">' + title + '</a>'
      + pricingHtml
      + '</div>'
      + '</div>'
      + '<div class="related-product-card__actions">' + atcHtml + '</div>'
      + '</article>'
      + '</div>';
  }

  async function fetchProducts(productId) {
    // "Similar" products first (Shopify's `related` intent is auto-generated),
    // then curated `complementary`, then the generic default.
    var urls = [
      '/recommendations/products.json?product_id=' + productId + '&limit=8&intent=related',
      '/recommendations/products.json?product_id=' + productId + '&limit=8&intent=complementary',
      '/recommendations/products.json?product_id=' + productId + '&limit=8'
    ];

    for (var i = 0; i < urls.length; i++) {
      try {
        var res = await fetch(urls[i]);
        if (!res.ok) continue;
        var data = await res.json();
        var products = data.products || [];
        if (products.length > 0) return products;
      } catch (e) {
        continue;
      }
    }
    return [];
  }

  // Guaranteed fallback: same-collection products rendered server-side by
  // cart-drawer.liquid. Used only when the recommendations API returns nothing.
  function getFallbackProducts() {
    var el = document.getElementById('CartDrawer-FBT-Fallback');
    if (!el) return [];
    try {
      var data = JSON.parse(el.textContent || el.innerHTML || '[]');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  async function refreshCartDrawer() {
    try {
      var res = await fetch('/?sections=cart-drawer');
      if (!res.ok) return;
      var data = await res.json();
      var html = data['cart-drawer'];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newDrawer = doc.getElementById('CartDrawer');
      var existingDrawer = document.getElementById('CartDrawer');
      if (newDrawer && existingDrawer) {
        existingDrawer.innerHTML = newDrawer.innerHTML;
        setTimeout(initFBT, 50);
      }
    } catch (e) {
      // silently fail
    }
  }

  async function addToCart(variantId, btn) {
    var originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('loading');
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      await refreshCartDrawer();
    } catch (e) {
      btn.innerHTML = originalHTML;
      btn.disabled = false;
      btn.classList.remove('loading');
    }
  }

  // Results per product id, so a re-render after the DOM is swapped out from
  // under us (see below) is instant instead of another network round trip.
  var productCache = {};

  // Paints `products` into the CURRENT live elements. Always call this with
  // freshly-queried nodes — never with references captured before an `await`.
  function render(container, slider, products) {
    if (products.length === 0) {
      container.style.display = 'none';
      // A marker, not truly empty: an empty slider is indistinguishable from
      // "never populated" and would immediately re-trigger another attempt.
      slider.innerHTML = '<div class="cart-fbt__empty" hidden></div>';
      return;
    }

    slider.innerHTML = products.map(renderCard).join('');
    container.style.display = 'flex';

    slider.querySelectorAll('.related-product-card__atc[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCart(btn.dataset.variantId, btn);
      });
    });
  }

  async function initFBT() {
    var container = document.getElementById('CartDrawer-FBT');
    if (!container) return;

    var productId = container.dataset.productId;
    if (!productId) return;

    var slider = document.getElementById('CartDrawer-FBT-Slider');
    if (!slider) return;

    // Already has content (loading state or products) for THIS instance of the
    // container — nothing to do. Also what stops our own writes from
    // re-triggering themselves through the childList observer in boot().
    if (slider.children.length > 0) return;

    // Fast path: we already know what to show for this product, so paint it
    // synchronously. This matters a lot — see the async-swap note below. A
    // synchronous repaint lands in the same frame as the swap that wiped us
    // out, so the strip never visibly disappears.
    if (productCache[productId]) {
      render(container, slider, productCache[productId]);
      return;
    }

    if (initFBT._busy) return;
    initFBT._busy = true;

    // Show a loading state immediately so the strip isn't blank during the
    // fetch (which reads as broken rather than pending).
    container.style.display = 'flex';
    slider.innerHTML = '<div class="cart-fbt__loading">Loading recommendations…</div>';

    try {
      var products = await fetchProducts(productId);
      if (products.length === 0) products = getFallbackProducts();
      productCache[productId] = products;

      // CRITICAL: re-query instead of reusing the nodes captured above.
      //
      // On add-to-cart, product-form.js publishes cartUpdate with
      // source 'product-form'. <cart-drawer-items> subscribes to that
      // (cart.js connectedCallback) and, for any source other than
      // 'cart-items', runs onCartUpdate() — which fetches the cart section and
      // does `targetElement.replaceWith(sourceElement)` on <cart-drawer-items>.
      //
      // That fetch resolves independently of ours, so it frequently lands while
      // we're awaiting above and detaches the container we captured. Writing to
      // those stale nodes "succeeds" silently but paints into an orphaned tree —
      // which is exactly why this looked broken on add-to-cart while the cart
      // icon (publishes nothing) and quantity changes (source 'cart-items', so
      // that subscriber early-returns) worked fine.
      container = document.getElementById('CartDrawer-FBT');
      slider = document.getElementById('CartDrawer-FBT-Slider');
      if (!container || !slider) return;
      if (slider.children.length > 0 && !slider.querySelector('.cart-fbt__loading')) return;

      render(container, slider, products);
    } finally {
      initFBT._busy = false;
    }
  }

  function boot() {
    initFBT();

    // Two things can require us to (re-)populate the strip:
    //
    // 1) The drawer becomes visible — <cart-drawer> gains the "active" class
    //    (component-cart-drawer.css: .drawer { visibility: hidden } / .drawer.active
    //    { visibility: visible }), regardless of what opened it (add-to-cart,
    //    the cart icon, any app).
    //
    // 2) The container gets silently replaced with a fresh, empty copy AFTER
    //    we've already populated it — e.g. by Dawn's own cart refresh, or by
    //    another app re-rendering part of the drawer — WITHOUT the drawer ever
    //    closing and reopening. In that case "active" never changes again, so
    //    watching only the class would miss it and leave an empty, invisible
    //    strip on screen. Watching childList/subtree too catches this: the
    //    fresh replacement has an empty slider, so initFBT() re-populates it.
    //    (The children-length guard inside initFBT is what stops this same
    //    childList watch from re-triggering on our OWN content writes below —
    //    see the comment there.)
    if ('MutationObserver' in window) {
      new MutationObserver(function () {
        var drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.classList.contains('active')) initFBT();
      }).observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.initCartFBT = initFBT;
})();
